module.exports = __webpack_public_path__ + "assets/img/report-data-bg-2.fffdc6ee.png";